import { useBlocker } from 'react-router-dom';
import { CoreDialogContent } from '@youscience/core';

import { DialogFooter } from './DialogFooter';

import { sxStyles, StyledDialog, StyledDialogTitle } from './SaveChangesModal.styles';

interface SaveChangesModalProps {
  hasUnsavedChanges: boolean;
  onContinue?: () => void;
  onCancel?: () => void;
  onSaveChanges: (isUpdateForAllStudents?: boolean) => Promise<void> | void;
}

export const SaveChangesModal = ({
  onContinue = () => {},
  onCancel = () => {},
  onSaveChanges,
  hasUnsavedChanges,
}: SaveChangesModalProps) => {
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) => hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname,
  );

  const handleOnCancel = () => {
    blocker.reset && blocker.reset();

    onCancel();
  };

  const handleOnContinue = () => {
    blocker.proceed && blocker.proceed();

    onContinue();
  };

  const handleOnSaveChanges = async () => {
    await onSaveChanges();

    blocker.proceed && blocker.proceed();
  };

  return (
    <StyledDialog open={blocker.state === 'blocked'} onClose={onCancel}>
      <StyledDialogTitle>You have unsaved changes</StyledDialogTitle>

      <CoreDialogContent sx={sxStyles.contentBody}>Are you sure you want to continue?</CoreDialogContent>

      <DialogFooter onGoBack={handleOnCancel} onSaveChanges={handleOnSaveChanges} onContinue={handleOnContinue} />
    </StyledDialog>
  );
};
